import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    startingPosition: { label: "Starting asset Y position (default is 0)", type: FIELD_TYPES.TEXT },
    animationDuration: { label: "Animation duration (in seconds)", type: FIELD_TYPES.TEXT },
    advancedAssetConfig: { label: "Advanced asset config", type: FIELD_TYPES.NESTED, fields: AssetAdvancedConfig }
  }
};
